import { Outlet, useParams, Navigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import ProjectPhaseStepper from './ProjectPhaseStepper';
import HelpCaptureEntry from './help-capture/HelpCaptureEntry';

// Shared layout for all /projects/:projectId/* routes. Commit 1 hoisted
// Sidebar out of 13 per-page imports; Commit 2 adds the persistent
// SDLC phase stepper above <Outlet />.
export default function ProjectLayout() {
  const { projectId } = useParams<{ projectId: string }>();

  // Route pattern guarantees projectId; bail explicitly if a misconfigured
  // route slips one through (defensive — never observed in practice).
  if (!projectId) return <Navigate to="/projects" replace />;

  return (
    <div className="flex min-h-screen" style={{ background: 'var(--bg)' }}>
      <Sidebar />
      <main className="flex-1 flex flex-col min-w-0">
        <ProjectPhaseStepper projectId={projectId} />
        <Outlet />
      </main>
      {/* HELP.A2b (#2055) — see HelpCaptureEntry.tsx's header. Renders
          unconditionally: whether tenants.help_agent_enabled is on for this
          tenant is deliberately NOT exposed to the frontend (HELP.A7a's own
          adjudication stripped it from every tenant-info response to avoid
          leaking the flag — see MIGRATION_SLOTS.md / that story's PR). A
          disabled tenant therefore sees this button but a submission fails
          generically, same as the backend's stealth posture. Solving that
          UX rough edge would need a dedicated capability-check endpoint at
          least as stealthy as the capture route itself — bigger than this
          story's minimal-surface mandate, disclosed here rather than
          silently accepted. */}
      <HelpCaptureEntry projectId={projectId} />
    </div>
  );
}
